import { ConnectorIds } from '@/common/constants';
import { IConnector } from '@/common/dto/connectors/Interface';
import { TagTypes, baseApi } from '@/store/baseApi';

const baseUrl = '/connector';

const supportsAutoMapping = [ConnectorIds.FormstackForm, ConnectorIds.Documents];

export const connectorsApi = baseApi
  .enhanceEndpoints({ addTagTypes: [TagTypes.Connector] })
  .injectEndpoints({
    endpoints: (build) => ({
      getConnectors: build.query<IConnector[], void>({
        query: () => baseUrl,
        transformResponse: (res: { items: IConnector[] }) => res?.items ?? [],
        providesTags: [TagTypes.Connector],
      }),
      createFieldAutoMapping: build.mutation<
        string,
        { connectorId: ConnectorIds; sourceStepId?: string; targetStepId: string }
      >({
        query: ({ connectorId, targetStepId, sourceStepId }) => {
          if (!supportsAutoMapping.includes(connectorId)) {
            throw new Error('Invalid connectorId');
          }
          return {
            url: `${baseUrl}/${connectorId}/fields-auto-mapping`,
            method: 'POST',
            body: { targetStepId, sourceStepId },
          };
        },
      }),
    }),
  });

export const { useGetConnectorsQuery, useCreateFieldAutoMappingMutation } = connectorsApi;
